"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var immer_1 = require("immer");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var message_1 = require("./message");
var RxStore = /** @class */ (function () {
    function RxStore(stateSubject, middleware, options) {
        this._middleware = [];
        this._state$ = stateSubject;
        this._options = options;
        this._middleware = middleware;
    }
    RxStore.of = function (state, middleware, options) {
        return new RxStore(state, middleware, options);
    };
    RxStore.prototype._next = function (updateFunctionOrNextState, message, stack) {
        if (message === void 0) { message = message_1.RESTATE_UPDATE_MESSAGE; }
        try {
            var currentStatePackage = this._state$.value;
            var isUpdateFunction = updateFunctionOrNextState instanceof Function;
            // we accept either a new state object or a update function
            // a) If we receive an object, we create a draft from that object. The draft will be used in the middleware
            // b) If we receive an function, we create a draft from the current state.
            var draft = isUpdateFunction
                ? immer_1.createDraft(currentStatePackage.state)
                : immer_1.createDraft(updateFunctionOrNextState);
            if (updateFunctionOrNextState instanceof Function) {
                var ret = updateFunctionOrNextState(draft);
                if (ret !== undefined) {
                    draft = immer_1.createDraft(ret);
                }
            }
            recursiveMiddlewareHandler({
                middleware: this._middleware,
                nextState: draft,
                currentState: this.state,
                message: message
            });
            var _patches_1 = null;
            var _inversePatches_1 = null;
            var nextState = immer_1.finishDraft(draft, function (patches, inversePatches) {
                _patches_1 = patches;
                _inversePatches_1 = inversePatches;
            });
            var nextStatePackage = {
                message: message,
                state: nextState,
                patches: _patches_1,
                inversePatches: _inversePatches_1,
                stack: this._options.dev ? stack : undefined
            };
            this._state$.next(nextStatePackage);
            return nextStatePackage;
        }
        catch (e) {
            return { state: this._state$.value, message: message };
        }
    };
    RxStore.prototype.next = function (updateFunctionOrNextState, message) {
        if (message === void 0) { message = message_1.RESTATE_UPDATE_MESSAGE; }
        var stack = getStackTrace(this._options.dev);
        this._next(updateFunctionOrNextState, message, stack);
    };
    RxStore.prototype.nextAsync = function (updateFunctionOrNextState, message) {
        var _this = this;
        if (message === void 0) { message = message_1.RESTATE_UPDATE_MESSAGE; }
        var stack = getStackTrace(this._options.dev);
        setTimeout(function () {
            _this._next(updateFunctionOrNextState, message, stack);
        }, 0);
    };
    RxStore.prototype.dispatch = function (message) {
        var _this = this;
        var stack = getStackTrace(this._options.dev);
        setTimeout(function () {
            _this._next(function () { }, message, stack);
        }, 0);
    };
    Object.defineProperty(RxStore.prototype, "state", {
        get: function () {
            return this._state$.value.state;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RxStore.prototype, "state$", {
        get: function () {
            return this._state$.pipe(operators_1.observeOn(rxjs_1.queueScheduler));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RxStore.prototype, "options", {
        get: function () {
            return this._options;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RxStore.prototype, "middleware", {
        get: function () {
            return this._middleware;
        },
        enumerable: true,
        configurable: true
    });
    return RxStore;
}());
exports.RxStore = RxStore;
function recursiveMiddlewareHandler(_a) {
    var middleware = _a.middleware, nextState = _a.nextState, currentState = _a.currentState, message = _a.message;
    if (middleware.length === 0) {
        return;
    }
    var nextMiddleware = middleware[0];
    nextMiddleware({
        nextState: nextState,
        currentState: currentState,
        message: message
    });
    var remainingMiddleware = middleware.slice(1, middleware.length);
    return recursiveMiddlewareHandler({
        middleware: remainingMiddleware,
        nextState: nextState,
        currentState: currentState,
        message: message
    });
}
function getStackTrace(dev) {
    if (dev) {
        return new Error().stack;
    }
    else {
        return undefined;
    }
}
//# sourceMappingURL=rx-store.js.map